/**
 * @author       Pavlo Androshchuk
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Get short address, city, state, zip etc. from full formatted address text
 */

import { checkAddressHidden } from './address'

export interface DecomposedFormattedAddress {
  shortAddress?: string
  city?: string
  state?: string
  zip?: string
}

export const decomposeFormattedAddress = (
  formattedAddress?: string | null
): DecomposedFormattedAddress => {
  if (typeof formattedAddress !== 'string') {
    return {}
  }
  const [shortAddress, city, szToken]: Array<string | undefined> = formattedAddress.split(/\s*,\s*/)
  const [state, zip] = szToken ? szToken.split(' ') : []
  return {
    shortAddress: checkAddressHidden(shortAddress) ? '' : shortAddress,
    city,
    state,
    zip,
  }
}
